<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'app',
  mounted() {
    // this.timeId = setInterval(() => {
    //   this.$store.dispatch('RefreshToken')
    // }, 10000) // 每隔20分钟刷新token
  },
  data() {
    return {
      timeId: 0
    }
  },
  computed: {
    ...mapGetters(['langType'])
  },
  watch: {
    $route(to) {
      this.$nextTick(() => {
        this.$zh_tran(this.langType)
      })
    }
  },
  destroyed() {
    clearInterval(this.timeId)
  }
}
</script>
